(function() {
  var SimplifyOperation;

  SimplifyOperation = exports;

  SimplifyOperation._pointsToKeep = [];


  /*
   * Whee. Simplify an array of points given the tolerance
   */

  SimplifyOperation.simplify = function(points, tolerance) {
    var finalPoints, firstPoint, i, j, lastPoint, len, pointsToKeep;
    pointsToKeep = [];
    if (points.length < 3) {
      return points;
    }
    firstPoint = 0;
    lastPoint = points.length - 1;
    pointsToKeep.push(firstPoint);
    pointsToKeep.push(lastPoint);
    while (points[firstPoint].equals(points[lastPoint])) {
      lastPoint--;
      pointsToKeep.push(lastPoint);
    }
    pointsToKeep = SimplifyOperation._douglasPeuckerReduction(points, firstPoint, lastPoint, tolerance, pointsToKeep);
    pointsToKeep.sort(SimplifyOperation._compareNumbers);
    finalPoints = [];
    for (j = 0, len = pointsToKeep.length; j < len; j++) {
      i = pointsToKeep[j];
      finalPoints.push(points[i]);
    }
    return finalPoints;
  };

  SimplifyOperation._compareNumbers = function(a, b) {
    return a - b;
  };


  /*
   * Actual simplify algorithm, ganked shamelessly from OpenLayers' implementation
   */

  SimplifyOperation._douglasPeuckerReduction = function(points, firstPoint, lastPoint, tolerance, pointsToKeep) {
    var distance, i, ind, indexFarthest, j, len, maxDistance, pointarr;
    maxDistance = 0;
    indexFarthest = 0;
    pointarr = points.slice(firstPoint, lastPoint);
    for (ind = j = 0, len = pointarr.length; j < len; ind = ++j) {
      i = pointarr[ind];
      distance = SimplifyOperation._perpendicularDistance(points[firstPoint], points[lastPoint], i);
      if (distance > maxDistance) {
        maxDistance = distance;
        indexFarthest = ind + firstPoint;
      }
    }
    if (maxDistance > tolerance && indexFarthest !== firstPoint) {
      pointsToKeep.push(indexFarthest);
      pointsToKeep = SimplifyOperation._douglasPeuckerReduction(points, firstPoint, indexFarthest, tolerance, pointsToKeep);
      pointsToKeep = SimplifyOperation._douglasPeuckerReduction(points, indexFarthest, lastPoint, tolerance, pointsToKeep);
    }
    return pointsToKeep;
  };

  SimplifyOperation._perpendicularDistance = function(point1, point2, point) {
    var area, bottom, height;
    area = Math.abs(0.5 * (point1.lng * point2.lat + point2.lng * point.lat + point.lng * point1.lat - point2.lng * point1.lat - point.lng * point2.lat - point1.lng * point.lat));
    bottom = Math.sqrt(Math.pow(point1.lng - point2.lng, 2) + Math.pow(point1.lat - point2.lat, 2));
    height = area / bottom * 2;
    return height;
  };

}).call(this);
